import { getUserInfo,getLanguageList } from "../../api/user";

import { getToken, setToken, removeToken, getCookie, setCookie } from '@/utils/auth'

const user = {
  state: {
    language: getCookie('language') ? getCookie('language') : 'en',
    languageName: getCookie('languageName') ? getCookie('languageName') : 'English',
    token: getToken() ? getToken() : false,
    name: '',
    avatar: '',
    roles: [],
    menu: [],
    isDirection: getCookie('language') && getCookie('language') == 'fa' ? true : false,
    isApp: '',
    user:{},
    session_id:sessionStorage.getItem('session_id') || '',
    page_session_id:sessionStorage.getItem('page_session_id') || '',
    trigger:'',
    languageList: null,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ISAPP: (state, isApp) => {

      state.isApp = sessionStorage.getItem('isApp')||isApp
    },
    SET_USER:(state,user)=>{
      state.user = user
    },
    SET_LANGUAGENAME: (state, languageName) => {
      state.languageName = languageName
      setCookie('languageName', languageName)
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      setCookie('language', language)
    },
    SET_IS_DIRECTION: (state, isDirection) => {
      state.isDirection = isDirection
    },
    SET_SESSION_ID:(state,data)=>{
      state.session_id = data
    },
    SET_PAGE_SESSION:(state,data)=>{
      state.page_session_id = data
    },
    SET_TRIGGER:(state,data)=>{
      state.trigger = data
    },
    SET_LANGUAGELIST: (state, data) => {
      state.languageList = data
    },
  },

  actions: {
    setTrigger({commit},data){
      return new Promise(()=>{
        commit('SET_TRIGGER',data)
      })
    },
    setPageSession({commit},data){
      return new Promise(()=>{
        commit('SET_PAGE_SESSION',data)
      })
    },
    setSessionId({commit},data){
      return new Promise(()=>{
        commit('SET_SESSION_ID',data)
      })
    },
    setLanguageName({ commit }, languageName) {
      return new Promise(() => {
        commit('SET_LANGUAGENAME', languageName)
      })
    },
    setLanguage({ commit }, language) {
      return new Promise(() => {
        commit('SET_LANGUAGE', language)
      })
    },
    setIsDirection({ commit }, isDirection) {
      return new Promise(() => {
        commit('SET_IS_DIRECTION', isDirection)
      })
    },
    setToken({ commit }, token) {
      return new Promise(resolve => {
        commit('SET_TOKEN', token)
        resolve()
      })
    },
    setisApp({ commit }, isApp) {
      return new Promise(resolve => {
        commit('SET_ISAPP', isApp)
        resolve()
      })
    },
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      // console.log(userInfo, 22222)
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.smsCode).then(response => {
          console.log(response)
          console.log(response.token)
          setToken(response.token)
          commit('SET_TOKEN', 'admin')
          // const data = response.data
          // setToken('admin')
          // commit('SET_TOKEN', 'admin')
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    RemoveUserInfo({commit,state},data){
      commit('SET_USER',data)
    },
    // 获取用户信息
    GetInfo({ commit, state },token) {
      return new Promise((resolve, reject) => {
        getUserInfo(token).then(response => {
          if(!state.user.id || state.user.id != response.data.id){
            posthog.identify(response.data.id);
          }
          const data = response.data
// console.log(data)
          // if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
          //   commit('SET_ROLES', data.roles)
          // } else {
          //   reject('getInfo: roles must be a non-null array !')
          // }
          commit('SET_USER',data)
          commit('SET_NAME', data.userName)
          commit('SET_AVATAR', data.image)
          // commit('SET_ROLES', data.roles)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then((res) => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    // 获取语言
    getLanguageList({commit, state}) {
      return new Promise((resolve, reject) => {
        getLanguageList().then(response => {
          commit('SET_LANGUAGELIST', response.data)
          resolve(response)
        })
      })
    },
  }
}


export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js